export const CONTENT_SOURCE_UPDATE_STATUS_OK = 1
export const CONTENT_SOURCE_UPDATE_STATUS_KO = 2

export const IMG_POS_TOP = 'TOP'
export const IMG_POS_LEFT = 'LEFT'
export const IMG_POS_RIGHT = 'RIGHT'

export const IMG_SPACE_EQUAL = 'EQUAL'
export const IMG_SPACE_SMALL = 'SMALL'
